import React, { createContext, useContext, useEffect, useState } from "react";

const translations = {
  fr: {
    nav: { home: "Accueil", about: "À propos", team: "Notre équipe", packs: "Nos Packs", faq: "FAQ", contact: "Contact", client: "Espace Client", reserve: "Réserver maintenant" },
    footer: {
      tagline: "Votre partenaire de confiance pour l'immigration et les visas vers l'Australie et le Canada.",
      navigation: "Navigation", packs: "Nos Packs", contact: "Contact",
      address: "Siège social — Floride, États-Unis", rights: "Tous droits réservés.",
      legal: "Mentions légales", privacy: "Confidentialité", cgv: "CGV",
    },
    home: {
      heroOverline: "Immigration & Visa · Australie & Canada",
      heroTitle1: "Réalisez votre rêve de partir en", heroAus: "Australie", heroOr: "ou au", heroCan: "Canada",
      heroText: "Work & Travel Expert vous accompagne de A à Z : évaluation, visa, documents et installation. Un service premium, humain et fiable.",
      reserve: "Réserver maintenant", learnMore: "En savoir plus",
      statsDossiers: "Dossiers accompagnés", statsSatisfaction: "Taux de satisfaction", statsDest: "Destinations phares", statsSupport: "Support disponible",
      destOverline: "Nos destinations", destTitle: "Deux pays, mille opportunités",
      ausDesc: "Working Holiday Visa, permis de travail et installation sous le soleil australien.",
      canDesc: "Entrée Express, permis de travail et tirage au sort du visa canadien.",
      destination: "Destination", discoverPacks: "Découvrir les packs",
      processOverline: "Notre méthode", processTitle: "Un parcours simple et transparent",
      step1: "1. Évaluation", step1t: "Nous évaluons votre profil et votre éligibilité pour l'Australie ou le Canada.",
      step2: "2. Constitution du dossier", step2t: "Nous préparons et vérifions l'ensemble de vos documents.",
      step3: "3. Préparation & vérification", step3t: "Nous relisons et vérifions votre dossier, puis vous guidons pas à pas jusqu'à la finalisation de votre démarche.",
      step4: "4. Départ", step4t: "Vous obtenez votre visa et nous vous accompagnons jusqu'à l'installation.",
      whyOverline: "Nos avantages", whyTitle: "Pourquoi choisir Work & Travel Expert ?",
      adv1: "Entreprise américaine (LLC)", adv1t: "Une société officiellement enregistrée aux États-Unis (Floride), gage de sérieux et de fiabilité.",
      adv2: "Accompagnement personnalisé", adv2t: "Un conseiller dédié vous guide pas à pas, selon votre profil et votre projet.",
      adv3: "Paiement 100% sécurisé", adv3t: "Vos paiements sont traités par Stripe avec un chiffrement de niveau bancaire.",
      adv4: "Assistance jusqu'à l'installation", adv4t: "Nous vous accompagnons jusqu'à votre arrivée et votre installation sur place.",
      testiOverline: "Ils nous ont fait confiance", testiTitle: "Avis clients",
      testiText: "Découvrez les témoignages de nos clients partis en Australie et au Canada.",
      testiEmpty: "Les premiers avis de nos clients seront publiés prochainement.",
      ctaTitle: "Prêt à commencer votre nouvelle vie ?", ctaText: "Découvrez nos packs et réservez votre accompagnement dès aujourd'hui.", ctaBtn: "Voir nos packs",
    },
    announce: {
      badge: "Annonce officielle",
      title: "Ouverture officielle en septembre",
      p1: "Après plusieurs mois de développement et de préparation, Work Travel Expert est fier d'annoncer que son ouverture officielle est prévue en septembre.",
      p2: "Notre plateforme proposera un accompagnement complet pour les projets de mobilité internationale, avec un espace client sécurisé, un suivi des dossiers en temps réel, des paiements sécurisés via Stripe, une prise de rendez-vous en ligne et une équipe dédiée pour accompagner chaque candidat.",
      p3: "Nous avons hâte de vous accueillir et de vous accompagner dans votre projet au Canada 🇨🇦 et en Australie 🇦🇺.",
      p4: "La date officielle d'ouverture sera annoncée prochainement.",
      countdownLabel: "Ouverture en septembre",
      days: "Jours", hours: "Heures", minutes: "Min", seconds: "Sec",
      cta: "Être informé de l'ouverture",
      placeholder: "Votre adresse e-mail", submit: "Me prévenir", sending: "Envoi…",
      success: "Merci ! Vous serez informé(e) dès l'ouverture.",
      error: "Une erreur est survenue. Veuillez réessayer.",
      canada: "Canada", canadaTag: "Entrée Express · Permis de travail",
      australia: "Australie", australiaTag: "Working Holiday · Installation",
    },
    packs: {
      overline: "Nos offres d'accompagnement", title: "Nos Packs",
      subtitle: "Choisissez la formule adaptée à votre projet. Paiement 100% sécurisé par Stripe.",
      recommended: "RECOMMANDÉ", reserve: "Réserver maintenant", redirect: "Redirection…",
      note: "Paiement sécurisé par carte bancaire via Stripe. Vous recevrez une confirmation par email.",
      loginNeeded: "Veuillez vous connecter pour réserver.",
      consentTitle: "Confirmation avant réservation",
      consent: "Je reconnais avoir lu et compris les conditions d'éligibilité, les avertissements importants et les informations relatives aux visas. Je comprends que la décision finale appartient exclusivement aux autorités d'immigration compétentes (IRCC Canada ou Department of Home Affairs Australie) et que Work & Travel Expert ne garantit pas l'obtention d'un visa.",
      consentRequired: "Veuillez confirmer avoir lu et compris les conditions d'éligibilité.",
      confirm: "Confirmer et payer", cancel: "Annuler",
    },
    common: { back: "Retour à l'accueil" },
    access: {
      badge: "Nouveau · Plateforme unifiée",
      title: "Accessible aux clients francophones",
      intro: "Work Travel Expert est désormais accessible aux clients francophones résidant en :",
      others: "Les candidats des autres pays restent également les bienvenus grâce à l'option « Autre pays » lors de l'inscription.",
      unified: "Toutes les démarches se font désormais depuis une seule plateforme sécurisée, moderne et unifiée, avec un accompagnement personnalisé du début à la fin.",
      cta: "Créer mon compte",
      france: "France", belgium: "Belgique", switzerland: "Suisse", luxembourg: "Luxembourg", other: "Autre pays",
    },
    journey: {
      badge: "Accompagnement premium",
      title: "Vous êtes accompagné à chaque étape",
      p1: "Notre équipe vous accompagne pas à pas tout au long de votre parcours. Nous vous guidons dans la préparation et l'organisation de votre dossier et restons à vos côtés jusqu'à la finalisation de vos démarches.",
      p2: "Pour votre sécurité et afin que vous gardiez le contrôle de vos informations personnelles, vous effectuez simplement la validation finale directement sur la plateforme officielle concernée.",
      p3: "Vous n'êtes jamais seul : Work Travel Expert vous accompagne à chaque étape.",
      item1: "Préparation et organisation complète de votre dossier",
      item2: "Guide et accompagnement pas à pas dans vos démarches",
      item3: "Relecture et vérification administrative de vos documents",
      item4: "Assistance et accompagnement tout au long de votre parcours",
    },
    trust: {
      badge: "Transparence & confiance",
      title: "Entreprise officiellement enregistrée aux États-Unis",
      p1: "Work Travel Expert L.L.C. est une entreprise officiellement enregistrée dans l'État de Floride.",
      p2: "Parce que votre confiance est essentielle, nous avons choisi d'être totalement transparents sur l'identité et l'existence de notre entreprise. Vous pouvez consulter notre certificat officiel et vérifier par vous-même les informations publiques relatives à Work Travel Expert.",
      p3: "Votre confiance mérite des preuves concrètes et accessibles.",
      docLabel: "Numéro de document", statusLabel: "Statut", statusValue: "Active",
      stateLabel: "État", stateValue: "Floride, États-Unis",
      issuerLabel: "Délivré par", issuerValue: "Florida Department of State",
      btnCert: "Consulter notre certificat officiel",
      btnVerify: "Vérifier notre entreprise (Sunbiz)",
      caption: "Certificate of Status — Florida Department of State",
    },
    florida: {
      badge: "Société américaine · Floride, USA",
      title: "Société américaine basée en Floride",
      p1: "Work Travel Expert LLC est une société officiellement enregistrée dans l'État de Floride (États-Unis). Depuis notre siège social en Floride, nous accompagnons les candidats francophones de France, de Belgique, de Suisse, du Luxembourg et d'autres pays dans leurs projets de mobilité internationale.",
      p2: "Cette présence aux États-Unis reflète notre engagement à offrir un service professionnel, moderne et sécurisé, tout en accompagnant nos clients avec un suivi personnalisé à chaque étape de leur projet.",
      note: "La Floride est le siège social de l'entreprise, tandis que nos principales destinations et nos services concernent l'Australie et le Canada.",
      item1: "Société américaine officiellement enregistrée",
      item2: "Siège social en Floride",
      item3: "Plateforme unique et sécurisée",
      item4: "Accompagnement personnalisé en français",
      item5: "Destinations principales : Australie 🇦🇺 et Canada 🇨🇦",
      imgCaption: "Floride, États-Unis",
    },
    select: {
      back: "Retour à l'accueil",
      title: "Choisissez votre espace",
      subtitle: "Sélectionnez l'espace qui vous correspond pour vous connecter.",
      client: "Espace Client", clientDesc: "Suivez votre dossier, déposez vos documents, prenez rendez-vous et gérez vos paiements.",
      staff: "Espace Collaborateur", staffDesc: "Gérez les dossiers clients, la messagerie, les documents et les rendez-vous.",
      admin: "Espace Administrateur", adminDesc: "Pilotez la plateforme : clients, paiements, personnel, contrats et statistiques.",
      cta: "Se connecter",
      note: "Une seule connexion sécurisée pour toute la plateforme. Après authentification, vous êtes automatiquement redirigé vers votre espace selon votre rôle.",
    },
  },
  en: {
    nav: { home: "Home", about: "About", team: "Our team", packs: "Our Packages", faq: "FAQ", contact: "Contact", client: "Client Area", reserve: "Book now" },
    footer: {
      tagline: "Your trusted partner for immigration and visas to Australia and Canada.",
      navigation: "Navigation", packs: "Our Packages", contact: "Contact",
      address: "Head office — Florida, USA", rights: "All rights reserved.",
      legal: "Legal notice", privacy: "Privacy", cgv: "Terms",
    },
    home: {
      heroOverline: "Immigration & Visa · Australia & Canada",
      heroTitle1: "Make your dream of moving to", heroAus: "Australia", heroOr: "or", heroCan: "Canada", 
      heroText: "Work & Travel Expert supports you from A to Z: assessment, visa, documents and settling in. A premium, human and reliable service.",
      reserve: "Book now", learnMore: "Learn more",
      statsDossiers: "Cases handled", statsSatisfaction: "Satisfaction rate", statsDest: "Key destinations", statsSupport: "Support available",
      destOverline: "Our destinations", destTitle: "Two countries, endless opportunities",
      ausDesc: "Working Holiday Visa, work permit and settling under the Australian sun.",
      canDesc: "Express Entry, work permit and the Canadian visa lottery.",
      destination: "Destination", discoverPacks: "Discover the packages",
      processOverline: "Our method", processTitle: "A simple and transparent journey",
      step1: "1. Assessment", step1t: "We assess your profile and eligibility for Australia or Canada.",
      step2: "2. Building your file", step2t: "We prepare and review all of your documents.",
      step3: "3. Preparation & review", step3t: "We review and check your file, then guide you step by step until your procedure is finalised.",
      step4: "4. Departure", step4t: "You obtain your visa and we support you until you settle in.",
      whyOverline: "Our advantages", whyTitle: "Why choose Work & Travel Expert?",
      adv1: "American company (LLC)", adv1t: "A company officially registered in the United States (Florida), a mark of seriousness and reliability.",
      adv2: "Personalized support", adv2t: "A dedicated advisor guides you step by step, based on your profile and project.",
      adv3: "100% secure payment", adv3t: "Your payments are processed by Stripe with bank-level encryption.",
      adv4: "Support until you settle in", adv4t: "We support you until your arrival and your settlement on site.",
      testiOverline: "They trusted us", testiTitle: "Client reviews",
      testiText: "Discover the testimonials of our clients who moved to Australia and Canada.",
      testiEmpty: "Our first client reviews will be published soon.",
      ctaTitle: "Ready to start your new life?", ctaText: "Discover our packages and book your support today.", ctaBtn: "See our packages",
    },
    announce: {
      badge: "Official announcement",
      title: "Official opening in September",
      p1: "After several months of development and preparation, Work Travel Expert is proud to announce that its official opening is scheduled for September.",
      p2: "Our platform will offer complete support for international mobility projects, with a secure client area, real-time file tracking, secure payments via Stripe, online appointment booking and a dedicated team to support every candidate.",
      p3: "We look forward to welcoming you and supporting your project in Canada 🇨🇦 and Australia 🇦🇺.",
      p4: "The official opening date will be announced soon.",
      countdownLabel: "Opening in September",
      days: "Days", hours: "Hours", minutes: "Min", seconds: "Sec",
      cta: "Get notified of the opening",
      placeholder: "Your email address", submit: "Notify me", sending: "Sending…",
      success: "Thank you! You'll be notified as soon as we open.",
      error: "Something went wrong. Please try again.",
      canada: "Canada", canadaTag: "Express Entry · Work permit",
      australia: "Australia", australiaTag: "Working Holiday · Settling in",
    },
    packs: {
      overline: "Our support offers", title: "Our Packages",
      subtitle: "Choose the plan that fits your project. 100% secure payment by Stripe.",
      recommended: "RECOMMENDED", reserve: "Book now", redirect: "Redirecting…",
      note: "Secure card payment via Stripe. You will receive a confirmation by email.",
      loginNeeded: "Please log in to book.",
      consentTitle: "Confirmation before booking",
      consent: "I acknowledge that I have read and understood the eligibility conditions, important warnings and visa-related information. I understand that the final decision rests exclusively with the competent immigration authorities (IRCC Canada or Department of Home Affairs Australia) and that Work & Travel Expert does not guarantee that a visa will be granted.",
      consentRequired: "Please confirm that you have read and understood the eligibility conditions.",
      confirm: "Confirm and pay", cancel: "Cancel",
    },
    common: { back: "Back to home" },
    access: {
      badge: "New · Unified platform",
      title: "Open to French-speaking clients",
      intro: "Work Travel Expert is now available to French-speaking clients living in:",
      others: "Candidates from other countries are also welcome thanks to the “Other country” option at sign-up.",
      unified: "Everything is now handled from a single secure, modern and unified platform, with personalized support from start to finish.",
      cta: "Create my account",
      france: "France", belgium: "Belgium", switzerland: "Switzerland", luxembourg: "Luxembourg", other: "Other country",
    },
    journey: {
      badge: "Premium support",
      title: "You are supported at every step",
      p1: "Our team supports you step by step throughout your journey. We guide you in preparing and organising your file and stay by your side until your procedure is finalised.",
      p2: "For your security, and so that you keep control of your personal information, you simply carry out the final validation directly on the relevant official platform.",
      p3: "You are never alone: Work Travel Expert supports you at every step.",
      item1: "Complete preparation and organisation of your file",
      item2: "Step-by-step guidance throughout your procedures",
      item3: "Administrative review and verification of your documents",
      item4: "Assistance and support throughout your journey",
    },
    trust: {
      badge: "Transparency & trust",
      title: "A company officially registered in the United States",
      p1: "Work Travel Expert L.L.C. is a company officially registered in the State of Florida.",
      p2: "Because your trust is essential, we have chosen to be fully transparent about the identity and existence of our company. You can view our official certificate and check for yourself the public information relating to Work Travel Expert.",
      p3: "Your trust deserves concrete and accessible proof.",
      docLabel: "Document number", statusLabel: "Status", statusValue: "Active",
      stateLabel: "State", stateValue: "Florida, USA",
      issuerLabel: "Issued by", issuerValue: "Florida Department of State",
      btnCert: "View our official certificate",
      btnVerify: "Verify our company (Sunbiz)",
      caption: "Certificate of Status — Florida Department of State",
    },
    florida: {
      badge: "American company · Florida, USA",
      title: "An American company based in Florida",
      p1: "Work Travel Expert LLC is a company officially registered in the State of Florida (United States). From our head office in Florida, we support French-speaking candidates from France, Belgium, Switzerland, Luxembourg and other countries in their international mobility projects.",
      p2: "This presence in the United States reflects our commitment to delivering a professional, modern and secure service, while supporting our clients with personalized guidance at every step of their project.",
      note: "Florida is the company's head office, while our main destinations and services concern Australia and Canada.",
      item1: "Officially registered American company",
      item2: "Head office in Florida",
      item3: "Single, secure platform",
      item4: "Personalized support in French",
      item5: "Main destinations: Australia 🇦🇺 and Canada 🇨🇦",
      imgCaption: "Florida, United States",
    },
    select: {
      back: "Back to home",
      title: "Choose your area",
      subtitle: "Select the area that matches your profile to log in.",
      client: "Client area", clientDesc: "Track your file, upload your documents, book appointments and manage your payments.",
      staff: "Collaborator area", staffDesc: "Manage client files, messaging, documents and appointments.",
      admin: "Administrator area", adminDesc: "Run the platform: clients, payments, staff, contracts and statistics.",
      cta: "Log in",
      note: "A single secure login for the whole platform. After authentication, you are automatically redirected to your area based on your role.",
    },
  },
};

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("wte_lang") || "fr");
  useEffect(() => { localStorage.setItem("wte_lang", lang); document.documentElement.lang = lang; }, [lang]);
  const t = (path) => {
    const parts = path.split(".");
    let cur = translations[lang];
    for (const p of parts) { cur = cur?.[p]; if (cur == null) return path; }
    return cur;
  };
  const toggle = () => setLang((l) => (l === "fr" ? "en" : "fr"));
  return <LanguageContext.Provider value={{ lang, setLang, toggle, t }}>{children}</LanguageContext.Provider>;
}

export const useLang = () => useContext(LanguageContext);
